import { Tag } from "@siteimprove/alfa-act";
/**
 * @public
 */
export class Stability extends Tag {
    static of(stability) {
        return new Stability(stability);
    }
    _stability;
    constructor(stability) {
        super();
        this._stability = stability;
    }
    get type() {
        return "stability";
    }
    get stability() {
        return this._stability;
    }
    equals(value) {
        return value instanceof Stability && value._stability === this._stability;
    }
    toJSON() {
        return {
            ...super.toJSON(),
            stability: this._stability,
        };
    }
}
/**
 * @public
 */
(function (Stability) {
    /**
     * For experimental rules. These rules are not necessarily compatible with
     * downstream data processing, and are subject to breaking changes without
     * notice
     */
    Stability.Experimental = Stability.of("experimental");
    /**
     * For stable rules. These rules follow the same basic principles and are
     * reasonably stable; their changes are tracked by normal semver numbering.
     */
    Stability.Stable = Stability.of("stable");
    /**
     * For deprecated rules. These rules are deprecated and will be removed
     * permanently after some grace period.
     */
    Stability.Deprecated = Stability.of("deprecated");
})(Stability || (Stability = {}));
//# sourceMappingURL=stability.js.map